<template>
  <div>
    <va-card>
      <div class="d-flex justify--space-between">

        {{$t('tables.product.serverSidePagination')}}

        <va-button color="info" @click="showMediumModal = true">

          {{ $t('buttons.product.add') }}
        </va-button>

      </div>

      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        :totalPages="totalPages"
        @page-selected="readItems"
        api-mode
      >
        <template slot="avatar" slot-scope="props">
          <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar">
        </template>
      </va-data-table>
    </va-card>
    <div class="modals">
      <va-modal
        v-model="showMediumModal"
        title="Добавить товар"
        :okText=" $t('modal.confirm') "
        :cancelText=" $t('modal.cancel') "

      >

        <form>
          <div >
            <div class="flex md12 sm12 xs12">
              <va-input
                v-model="product.name"
                placeholder="Название букета"
              />
            </div>

            <div  class="my-2">
              <h3>Размер</h3>
              <fieldset>

                <div v-for="size in sizes" :key="size.id">
                  <va-checkbox

                    :label="size.name"
                    :value="size"
                    :array-value="String(size.id)"
                    v-model="product.size"

                  />
                </div>

              </fieldset>
            </div>
            <div class="flex md12 sm12 xs12">
              <va-input
                class="my-2"
                v-model="product.description"
                type="textarea"
                placeholder="Описание"
                autosize
                :min-rows="4"
                :max-rows="10"
              />
            </div>
            <div class="flex xs12">

              <va-file-upload
                type="gallery"
                file-types=".png, .jpg, .jpeg"
                dropzone
                v-model="advancedGallery"
              />

            </div>

            <div  class="flex my-3">
              <h3>Цвет</h3>
              <fieldset>

                <div v-for="color in colors" :key="color.id">
                  <va-checkbox

                    :label="color.name"
                    :value="color"
                    :array-value="String(color.id)"
                    v-model="product.color"

                  />
                </div>

              </fieldset>
            </div>

            <div  class="flex my-2">
              <h3>Категория</h3>
              <fieldset>

                <div v-for="category in categories" :key="category.id">
                  <va-checkbox

                    :label="category.name"
                    :value="category"
                    :array-value="String(category.id)"
                    v-model="product.category"

                  />
                </div>

              </fieldset>
            </div>

            <div  class="flex my-2">
              <h3>Состав</h3>
              <fieldset>

                <div v-for="component in components" :key="component.id">
                  <va-checkbox

                    :label="component.name"
                    :value="component"
                    :array-value="String(component.id)"
                    v-model="product.component"

                  />
                </div>

              </fieldset>
            </div>

            <div  class="flex my-2">
              <h3>Повод</h3>
              <fieldset>

                <div v-for="reason in reasons" :key="reason.id">
                  <va-checkbox

                    :label="reason.name"
                    :value="reason"
                    :array-value="String(reason.id)"
                    v-model="product.reason"

                  />
                </div>

              </fieldset>
            </div>
            <div  class="flex mt-2">
              <h3>Тег</h3>
              <fieldset>

                <div v-for="reason in reasons" :key="reason.id">
                  <va-checkbox

                    :label="reason.name"
                    :value="reason"
                    :array-value="String(reason.id)"
                    v-model="product.reason"

                  />
                </div>

              </fieldset>
            </div>

          </div>

        </form>

      </va-modal>

    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      advancedGallery: [],
      perPage: 4,
      totalPages: 0,
      items: [],
      loading: false,
      showMediumModal: false,
      product: {
        name: '',
        description: '',
        size: [],
        uploadImg: '',
        color: [],
        category: [],
        component: [],
        reason: [],

      },
      sizes: [
        {
          id: 1,
          qty: 2,
          price: 1,
          name: 'L',
        },
        {
          id: 2,
          qty: 32,
          price: 1,
          name: 'M',
        },
        {
          id: 3,
          qty: 32,
          price: 1,
          name: 'XL',
        },
      ],
      colors: [
        {
          id: 1,
          name: 'Красный',
        },
        {
          id: 2,
          name: 'Зеленый',

        },
        {
          id: 3,
          name: 'Белый',

        },
      ],
      categories: [
        {
          id: 1,
          name: 'Весенние монобукеты',
        },
        {
          id: 2,
          name: 'Весенние букеты',

        },
        {
          id: 3,
          name: 'Весенние композиции',

        },
      ],
      components: [
        {
          id: 1,
          name: 'Компонент 1',
        },
        {
          id: 2,
          name: 'Компонент 2',

        },
        {
          id: 3,
          name: 'Компонент 3',

        },
      ],
      reasons: [
        {
          id: 1,
          name: 'День медицинского работника',
        },
        {
          id: 2,
          name: 'День учителя',

        },
        {
          id: 3,
          name: '8 марта',

        },
      ],
    }
  },
  computed: {
    fields () {
      return [{
        name: '__slot:avatar',
        width: '60px',
      }, {
        name: 'photo',
        title: this.$t('tables.product.photo'),
        width: '20%',
      }, {
        name: 'name',
        title: this.$t('tables.product.name'),
        width: '20%',
      }, {
        name: 'category',
        title: this.$t('tables.product.category'),
      },
      {
        name: 'category',
        title: this.$t('tables.product.category'),
      },
      {
        name: 'size',
        title: this.$t('tables.product.size'),
      },
      {
        name: 'price',
        title: this.$t('tables.product.price'),
      }]
    },
  },
  async created () {
    this.readItems()
  },
  methods: {
    async readItems (page = 0) {
      this.loading = true

      const params = {
        per_page: this.perPage,
        page: page,
      }

      await this.axios.get('https://reqres.in/api/users', { params })
        .then(response => {
          this.items = response.data.data
          this.totalPages = response.data.total_pages
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss">
  .data-table-server-pagination---avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
</style>
